// extracted by mini-css-extract-plugin
export default {"container":"PricingCalculatorServices_container__oQIwB","columns":"PricingCalculatorServices_columns__JM0DL","column":"PricingCalculatorServices_column__y111x"};